import { Box, CardMedia, Typography } from '@mui/material';
import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import './Quantally.css';

const NextArrow = ({ onClick }) => {
    return (
        <Box sx={{ py: { xs: .5, sm: .7, md: 1 }, px: { xs: 1.875, sm: 2.625, md: 3.375, lg: 4.125 } }} className="arrow next" onClick={onClick}>
            <i className='fas fa-angle-right'></i>
        </Box>
    );
};

const PrevArrow = ({ onClick }) => {
    return (
        <Box sx={{ py: { xs: .5, sm: .7, md: 1 }, px: { xs: 1.875, sm: 2.625, md: 3.375, lg: 4.125 } }} className="arrow prev" onClick={onClick}>
            <i className='fas fa-angle-left'></i>
        </Box>
    );
};

const Quantally = () => {
    const [quantallies, setQuantallies] = React.useState([]);

    React.useEffect(() => {
        fetch(`./quantally.json`)
            .then(res => res.json())
            .then(data => setQuantallies(data));
    }, [])
    const firstQuantally = quantallies.slice(0, 2)
    const secondQuantally = quantallies.slice(2, 4)
    const thirdQuantally = quantallies.slice(4, 6)
    const fourthQuantally = quantallies.slice(6, 8)

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        autoplay: true,
        lazyLoad: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    }

    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', py: '20px' }}>
                <Box className="first-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#4741E4' }}></Box>
                <Box className="second-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#7E89FF' }}></Box>
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#383838', textAlign: 'left', pl: { xs: '18px', sm: '22px', md: '28px', lg: '36px' } }}>
                    Decentralization Redefined on <span style={{ fontWeight: 700, color: '#433ED1' }}>Quantally</span>
                </Typography>
            </Box>

            <Box sx={{ pt: '10px', pb: { xs: '50px', sm: '55px', md: '75px', xl: '106px' }, pl: { xl: '70px' }, pr: { xl: '70px' } }}>
                <Slider {...settings}>
                    {/* first slider */}
                    <Box>
                        <Box sx={{ display: { sm: 'flex' } }}>
                            <Box>
                                {firstQuantally.map(quantally =>
                                    <Box key={quantally.id} sx={{ backgroundImage: { xs: 'linear-gradient(90deg, #949EFF 0%, #FFFFFF 100%)', sm: 'none' }, m: { xs: '16px', sm: '13px', md: '20px' }, p: { xs: '1px', sm: 0 } }}>
                                        <Box className="slide-box-hover" sx={{ p: { xs: '15px', sm: '12px', md: '20px' }, boxShadow: { sm: '1px 2px 26px -2px rgba(126, 123, 160, 0.1)' }, borderRadius: { xs: '0.613986px', sm: '10px' }, background: '#FFFFFF' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', pb: '10px' }}>
                                                <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>
                                                    <CardMedia
                                                        component="img"
                                                        sx={{ width: { sm: '68px', md: '95px', lg: '96px' } }}
                                                        image={quantally.img1}
                                                        alt="logo"
                                                    />
                                                </Box>
                                                <Box sx={{ display: { sm: 'none' } }}>
                                                    <CardMedia
                                                        component="img"
                                                        sx={{ width: '40px', pr: '10px' }}
                                                        image={quantally.img2}
                                                        alt="logo"
                                                    />
                                                </Box>
                                                <Typography sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '16px', sm: '18px', md: '20px', lg: '24px' }, lineHeight: { xs: '24px', sm: '28px', md: '36px' }, textAlign: 'left', color: '#2B2B2B', pl: '10px' }}>{quantally.name}</Typography>
                                            </Box>

                                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '14px', sm: '15px', md: '16.5px', lg: '18px' }, lineHeight: { xs: '25px', sm: '28px', md: '32px', lg: '38px' }, textAlign: 'left', color: '#383838', pt: '10px' }}>{quantally.description}</Typography>
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                            <Box>
                                {secondQuantally.map(quantally =>
                                    <Box key={quantally.id} sx={{ backgroundImage: { xs: 'linear-gradient(90deg, #949EFF 0%, #FFFFFF 100%)', sm: 'none' }, m: { xs: '16px', sm: '13px', md: '20px' }, p: { xs: '1px', sm: 0 } }}>
                                        <Box className="slide-box-hover" sx={{ p: { xs: '15px', sm: '12px', md: '20px' }, boxShadow: { sm: '1px 2px 26px -2px rgba(126, 123, 160, 0.1)' }, borderRadius: { xs: '0.613986px', sm: '10px' }, background: '#FFFFFF' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', pb: '10px' }}>
                                                <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>
                                                    <CardMedia
                                                        component="img"
                                                        sx={{ width: { sm: '68px', md: '95px', lg: '96px' } }}
                                                        image={quantally.img1}
                                                        alt="logo"
                                                    />
                                                </Box>
                                                <Box sx={{ display: { sm: 'none' } }}>
                                                    <CardMedia
                                                        component="img"
                                                        sx={{ width: '40px', pr: '10px' }}
                                                        image={quantally.img2}
                                                        alt="logo"
                                                    />
                                                </Box>
                                                <Typography sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '16px', sm: '18px', md: '20px', lg: '24px' }, lineHeight: { xs: '24px', sm: '28px', md: '36px' }, textAlign: 'left', color: '#2B2B2B', pl: '10px' }}>{quantally.name}</Typography>
                                            </Box>

                                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '14px', sm: '15px', md: '16.5px', lg: '18px' }, lineHeight: { xs: '25px', sm: '28px', md: '32px', lg: '38px' }, textAlign: 'left', color: '#383838', pt: '10px' }}>{quantally.description}</Typography>
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>

                    {/* second slider */}
                    <Box>
                        <Box sx={{ display: { sm: 'flex' } }}>
                            <Box>
                                {thirdQuantally.map(quantally =>
                                    <Box key={quantally.id} sx={{ backgroundImage: { xs: 'linear-gradient(90deg, #949EFF 0%, #FFFFFF 100%)', sm: 'none' }, m: { xs: '16px', sm: '13px', md: '20px' }, p: { xs: '1px', sm: 0 } }}>
                                        <Box className="slide-box-hover" sx={{ p: { xs: '15px', sm: '12px', md: '20px' }, boxShadow: { sm: '1px 2px 26px -2px rgba(126, 123, 160, 0.1)' }, borderRadius: { xs: '0.613986px', sm: '10px' }, background: '#FFFFFF' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', pb: '10px' }}>
                                                <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>
                                                    <CardMedia
                                                        component="img"
                                                        sx={{ width: { sm: '68px', md: '95px', lg: '96px' } }}
                                                        image={quantally.img1}
                                                        alt="logo"
                                                    />
                                                </Box>
                                                <Box sx={{ display: { sm: 'none' } }}>
                                                    <CardMedia
                                                        component="img"
                                                        sx={{ width: '40px', pr: '10px' }}
                                                        image={quantally.img2}
                                                        alt="logo"
                                                    />
                                                </Box>
                                                <Typography sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '16px', sm: '18px', md: '20px', lg: '24px' }, lineHeight: { xs: '24px', sm: '28px', md: '36px' }, textAlign: 'left', color: '#2B2B2B', pl: '10px' }}>{quantally.name}</Typography>
                                            </Box>

                                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '14px', sm: '15px', md: '16.5px', lg: '18px' }, lineHeight: { xs: '25px', sm: '28px', md: '32px', lg: '38px' }, textAlign: 'left', color: '#383838', pt: '10px' }}>{quantally.description}</Typography>
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                            <Box>
                                {fourthQuantally.map(quantally =>
                                    <Box key={quantally.id} sx={{ backgroundImage: { xs: 'linear-gradient(90deg, #949EFF 0%, #FFFFFF 100%)', sm: 'none' }, m: { xs: '16px', sm: '13px', md: '20px' }, p: { xs: '1px', sm: 0 } }}>
                                        <Box className="slide-box-hover" sx={{ p: { xs: '15px', sm: '12px', md: '20px' }, boxShadow: { sm: '1px 2px 26px -2px rgba(126, 123, 160, 0.1)' }, borderRadius: { xs: '0.613986px', sm: '10px' }, background: '#FFFFFF' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', pb: '10px' }}>
                                                <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>
                                                    <CardMedia
                                                        component="img"
                                                        sx={{ width: { sm: '68px', md: '95px', lg: '96px' } }}
                                                        image={quantally.img1}
                                                        alt="logo"
                                                    />
                                                </Box>
                                                <Box sx={{ display: { sm: 'none' } }}>
                                                    <CardMedia
                                                        component="img"
                                                        sx={{ width: '40px', pr: '10px' }}
                                                        image={quantally.img2}
                                                        alt="logo"
                                                    />
                                                </Box>
                                                <Typography sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '16px', sm: '18px', md: '20px', lg: '24px' }, lineHeight: { xs: '24px', sm: '28px', md: '36px' }, textAlign: 'left', color: '#2B2B2B', pl: '10px' }}>{quantally.name}</Typography>
                                            </Box>

                                            <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '14px', sm: '15px', md: '16.5px', lg: '18px' }, lineHeight: { xs: '25px', sm: '28px', md: '32px', lg: '38px' }, textAlign: 'left', color: '#383838', pt: '10px' }}>{quantally.description}</Typography>
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Slider>
            </Box>
        </div>
    );
};

export default Quantally;